import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { FONT, SPACING } from '../../styles/emotion';

export const ZolaBabyLogoContainer = styled.div<{ type?: string; showTagline?: boolean }>`
 ${({ type }) => {
   if (type === 'logomark') {
     return css`
       height: 24px;
       width: 140px;
     `;
   }
   return null;
 }};

${({ showTagline }) =>
  showTagline &&
  css`
    display: flex;
    flex-flow: column;
  `};
}
`;

export const ZolaLinkContainer = styled.a<{ type?: string; showTagline?: boolean }>`
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }

${({ showTagline }) =>
  showTagline &&
  css`
    display: flex;
    flex-flow: column;
  `};
}
`;

export const Tagline = styled.p`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)}
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  margin: 0;
  padding-top: 5px;
  padding-bottom: ${SPACING.MD};
`;
